import { PrimarySearchBarProps } from "declarations/common";
import React, { useState } from "react";
import { CiSearch } from "react-icons/ci";
import { IoCloseOutline, IoMicOutline } from "react-icons/io5";
import {
  getSpeechRecognition,
  isSpeechRecognitionSupported,
} from "utils/speechRecognition";

function SearchBar({
  onChange,
  placeholder,
  value,
  onSearch,
  onKeyDown,
  enableVoice = true,
  onVoiceResult,
}: PrimarySearchBarProps) {
  const [listening, setListening] = useState(false);
  const handleSearch = () => {
    onSearch && onSearch();
  };

  const handleClear = () => {
    onChange({ target: { value: "" } });
  };

  const handleVoiceInput = () => {
    const SpeechRecognition = getSpeechRecognition();
    if (!SpeechRecognition || listening) return;

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.interimResults = false;
    recognition.maxAlternatives = 1;
    recognition.onstart = () => setListening(true);
    recognition.onend = () => setListening(false);
    recognition.onerror = () => setListening(false);
    recognition.onresult = (event: any) => {
      const transcript = event.results?.[0]?.[0]?.transcript?.trim();
      if (!transcript) return;
      onVoiceResult?.(transcript);
      onChange({ target: { value: transcript } });
    };
    recognition.start();
  };

  return (
    <div className={ClassName.searchBarContainer}>
      <input
        type="search"
        value={value}
        className={ClassName.searchBar}
        placeholder={placeholder}
        onChange={(e) => onChange(e)}
        onKeyDown={onKeyDown}
      />
      {enableVoice && isSpeechRecognitionSupported() && (
        <button
          type="button"
          className={`${ClassName.iconButton} ${
            listening ? ClassName.listeningButton : ""
          }`}
          onClick={handleVoiceInput}
          aria-label="Voice search"
        >
          <IoMicOutline size={21} />
        </button>
      )}
      {value ? (
        <button
          type="button"
          className={ClassName.iconButton}
          onClick={handleClear}
          aria-label="Clear search"
        >
          <IoCloseOutline size={20} />
        </button>
      ) : null}
      <button
        type="button"
        className={ClassName.searchButton}
        onClick={handleSearch}
        aria-label="Search"
      >
        <CiSearch size={22} />
      </button>
    </div>
  );
}

export default SearchBar;

const ClassName = {
  searchBarContainer:
    "flex h-11 w-full max-w-md flex-shrink-0 flex-row items-center rounded-xl border border-slate-200 bg-white pl-4 pr-1 shadow-sm transition-colors focus-within:border-primary",
  searchBar: "min-w-0 flex-1 bg-transparent pr-2 text-sm text-primaryText",
  iconButton:
    "mr-2 h-8 w-8 rounded-full flex items-center justify-center text-secondaryText hover:bg-bgSecondary",
  listeningButton: "bg-primary text-white hover:bg-primary",
  searchButton:
    "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary text-white transition-colors hover:bg-red-600",
};
